import { type CSSProperties, type Ref } from 'react'

import { AdIncontent } from '@/components/common/Ad'
import { CardRec } from '@/components/common/Card'
import { useAds } from '@/components/providers/AdsProvider'
import { type RecType } from '@/defs/rec'
import { cn } from '@/utils/commonUtil'
import { getUniqueRecKey } from '@/utils/recUtil'

import styles from './CardGrid.module.scss'

type Props = {
  assumeInViewCount?: number
  gridRef?: Ref<HTMLUListElement>
  incontentIndexes?: number[]
  openLinksInNewTab?: boolean
  recs: RecType[]
  size?: 'sm' | 'lg'
  variant?: 'recs' | 'images' | 'embedded'
}

export const CardGrid = ({
  assumeInViewCount = 0,
  gridRef,
  incontentIndexes = [],
  openLinksInNewTab,
  recs,
  size = 'lg',
  variant = 'recs',
}: Props) => {
  const { galleryIncontentDisabled } = useAds()
  const flagsHide = variant === 'embedded'
  const statsHide = variant === 'embedded'
  const controls = variant === 'images' ? 'none' : 'right'

  return (
    <div className={cn(styles.container, { size, styles, variant })}>
      <div className={styles.inner}>
        <ul className={styles.grid} ref={gridRef}>
          {recs.map((rec, i) => (
            <li className={styles.rec} key={getUniqueRecKey(rec)} style={{ '--order': i } as CSSProperties}>
              <CardRec
                assumeInView={i < assumeInViewCount}
                clickOpensModal={variant === 'images'}
                controls={controls}
                flagsHide={flagsHide}
                openLinksInNewTab={openLinksInNewTab}
                rec={rec}
                size={size === 'sm' ? size : undefined}
                statsHide={statsHide}
              />
            </li>
          ))}
          {!galleryIncontentDisabled &&
            incontentIndexes.map((recIndex, i) => (
              <li className={styles.ad} key={i} style={{ '--order': recIndex } as CSSProperties}>
                <AdIncontent />
              </li>
            ))}
        </ul>
      </div>
    </div>
  )
}
